import {
	alpha,
	Stack,
	Step,
	StepConnector as MUIStepConnector,
	StepLabel,
	Stepper,
	StepperProps,
	useTheme
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useContext } from "react";
import Iconify from "src/components/Iconify";

import Context from "../context";

// ----------------------------------------------------------------------

const StepConnector = styled(MUIStepConnector)<{ color?: string }>(({ theme, color }) => ({
	top: 15,
	left: "calc(-50% + 30px)",
	right: "calc(50% + 30px)",
	"& .MuiStepConnector-line": {
		borderTopWidth: 1.5,
		borderColor: theme.palette.divider
	},
	"&.Mui-active, &.Mui-completed": {
		"& .MuiStepConnector-line": {
			borderColor: color
		}
	}
}));

// ----------------------------------------------------------------------

export type StepIconProps = {
	name: string;
	icon: string;
};

interface Props extends StepperProps {
	steps: StepIconProps[];
	activeStep: number;
}

export default function StepperIconsFlow({ steps, activeStep, sx, ...other }: Props) {
	const { theme } = useContext(Context);
	return (
		<Stepper
			activeStep={activeStep}
			alternativeLabel
			connector={<StepConnector color={theme?.colors.primary} />}
			sx={{ mb: 5, ...sx }}
			{...other}
		>
			{steps.map((step, index) => (
				<Step key={step.name}>
					<StepLabel
						StepIconComponent={() => (
							<StepIcon
								active={activeStep === index}
								completed={activeStep > index}
								icon={step.icon}
							/>
						)}
						sx={{
							"& .MuiStepLabel-label": {
								typography: "subtitle2",
								color:
									activeStep === index || index < activeStep
										? theme?.colors.primaryText
										: theme?.colors.secondaryText
							}
						}}
					>
						{step.name}
					</StepLabel>
				</Step>
			))}
		</Stepper>
	);
}

// ----------------------------------------------------------------------

type StepProps = {
	active: boolean;
	completed: boolean;
	icon: string;
};

function StepIcon({ active, completed, icon }: StepProps) {
	const { theme } = useContext(Context);

	const defaultTheme = useTheme();

	return (
		<Stack
			alignItems='center'
			justifyContent='center'
			sx={{
				color: alpha(defaultTheme.palette.text.disabled, 0.4),
				...((active || completed) && {
					color: theme?.colors.primary
				})
			}}
		>
			<Stack
				sx={{
					width: 30,
					height: 30,
					p: 1,
					borderRadius: "100%",
					backgroundColor: "currentColor",
					justifyContent: "center",
					alignItems: "center"
				}}
			>
				<Iconify height={14} icon={icon} sx={{ color: "white" }} width={14} />
			</Stack>
		</Stack>
	);
}
